import { render, staticRenderFns } from "./rec-swiper.vue?vue&type=template&id=7035c76c&scoped=true"
import script from "./rec-swiper.vue?vue&type=script&lang=js"
export * from "./rec-swiper.vue?vue&type=script&lang=js"
import style0 from "./rec-swiper.vue?vue&type=style&index=0&id=7035c76c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7035c76c",
  null
  
)

export default component.exports